import React from "react";
import { useAuth } from "../../Auth/AuthProvider";
import LoadingPage from "../LoadingPage";
import ForbiddenPage from "../ForbiddenPage";
import { useTranslation } from "react-i18next";
import { isAdminIt } from "../../utils/authUtils";

type AdminGuardProps = {
  children: React.ReactNode;
};

const AdminGuard: React.FC<AdminGuardProps> = ({ children }) => {
  const { user, isLoading, logout } = useAuth();
  const { t } = useTranslation();

  if (isLoading) {
    return <LoadingPage message={t("common.chargement")} />;
  }

  if (!isAdminIt(user)) {
    return <ForbiddenPage logout={logout} />;
  }

  return <>{children}</>;
};

export default AdminGuard;
